// The slot a placeholder keeps for the content it stood in for.
//
// A placeholder swaps itself for a chart and then has to say what arrived -- `onLoad` hands that
// over. It cannot hold the answer itself: what a caller wants is the mounted chart, and the only
// thing a placeholder could point at on its own is a wrapper it added for the purpose. So it opens
// an empty slot instead and the content fills it as it mounts, which lets the wrapper go.
//
// A chart standing outside a placeholder finds no slot and fills nothing.

import { createContext, useContext, useEffect } from 'react'

export const ChartFrameContext = createContext(null)

// Fill the placeholder's slot with what this chart mounted, and empty it again on the way out, so
// a slot never outlives the chart that answered for it. Safe anywhere -- outside a placeholder
// there is no slot and this does nothing.
export const useFillChartFrame = chartRef => {
  const slot = useContext(ChartFrameContext)

  useEffect(() => {
    if (!slot) return

    slot.current = chartRef.current

    return () => {
      slot.current = null
    }
  })
}
